import { LocalizedString } from '@synergy/models';
import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';
import { NewsPostDetailFormValues } from '../models/news-post-detail-form-values';
import { NewsPostDetailRequest } from '../models/news-post-detail-request';

const newsPostDetailState = (state: AppState) => state.contentManagement.newsPost.newsPostDetail;
const supportedLocales = (state: AppState) => state.supportedLocales;

export const newsPostDetailSelector = createSelector(newsPostDetailState, state => state.newsPost);
export const newsPostDetailRequestingSelector = createSelector(newsPostDetailState, state => state.requesting);

export const newsPostDetailFormValues = createSelector([newsPostDetailState, supportedLocales], (state, locales) => {
    const newsPost = state.newsPost;
    const getLocalizedString = (values: LocalizedString) => {
        const localizedString: LocalizedString = {};
        locales.forEach(locale => (localizedString[locale] = values[locale] ?? ''));
        return localizedString;
    };

    return {
        ...newsPost,
        image: newsPost?.image ? { name: '', pathname: newsPost.image['700x394'] } : null,
        title: getLocalizedString(newsPost?.title ?? {}),
        text: getLocalizedString(newsPost?.text ?? {}),
        publishAt: newsPost?.publishAt ?? null,
    };
});

export const newsPostDetailRequestSelector = (values: NewsPostDetailFormValues) =>
    createSelector(newsPostDetailState, state => {
        const image = values.image?.contentBase64 ? values.image : null;
        delete image?.pathname;

        const request: NewsPostDetailRequest = {
            id: state.newsPost?.id,
            image,
            title: values.title,
            text: values.text,
            publishAt: values.publishAt ?? new Date(),
        };

        return request;
    });
